export const CHAT_EDITABLE_OBJECT_KIND = 'Finding' as const;

export const CUSTOM_ROLE_OBJECT_KIND = 'CustomRole' as const;

export const CREDENTIAL_OBJECT_KIND = 'Credential' as const;

export const CUSTOM_ROLE_CREATE_DRAFT_ID = '__create__';

export type CustomRoleEditableField = 'name' | 'description';

export type CredentialEditableField = 'role' | 'roleId' | 'roleDescription';

export type ChatEditableObjectKind =
  | typeof CHAT_EDITABLE_OBJECT_KIND
  | typeof CUSTOM_ROLE_OBJECT_KIND
  | typeof CREDENTIAL_OBJECT_KIND;

export function isChatEditableObjectKind(
  objectKind: string | undefined,
): objectKind is ChatEditableObjectKind {
  return (
    objectKind === CHAT_EDITABLE_OBJECT_KIND ||
    objectKind === CUSTOM_ROLE_OBJECT_KIND ||
    objectKind === CREDENTIAL_OBJECT_KIND
  );
}
